import { render } from "./Cucc.vue?vue&type=template&id=7f01a320&ts=true"
import script from "./Cucc.vue?vue&type=script&lang=ts"
export * from "./Cucc.vue?vue&type=script&lang=ts"

import "./Cucc.vue?vue&type=style&index=0&id=7f01a320&lang=less"

import exportComponent from "/Users/user/Projects/simweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__